import styles from "./Messages.module.css";
import Markdown from "react-markdown";
import { useRef } from "react";
const WELCOME_MESSAGE = {
  role: "assistant",
  content: "hello how can i assist you right now?",
};
export function Messages({ messages }) {
  const messageEndRef = useRef(null);

  return (
    <div className={styles.messages}>
      {[WELCOME_MESSAGE, ...messages].map(({ role, content }, index) => {
        return (
          <div className={styles.message} key={index} data-role={role}>
            <div className={styles.markdown}>
              <Markdown>{content}</Markdown>
            </div>
          </div>
        );
      })}
      <div ref={messageEndRef} />
    </div>
  );
}
